var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isEmpty)?_c('nio-icon',{staticClass:"text-lg text-gray-400",attrs:{"name":"bold/subtract-circle"}}):_vm._t("default",[_vm._v(" "+_vm._s(_vm.value)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }